import React, { useState, useRef, useEffect } from "react";
import Author from "./Author";
import Contacts from "./Contacts";
import Copyright from "./Copyright";
import Menu from "./Menu";
import styles from "./Sidebar.module.scss";
import { useSiteMetadata } from "../../hooks";
import SiteThemeToggler from "./SiteThemeToggler";
import {
  algo,
  android,
  bootstrap,
  cpp,
  c,
  csharp,
  dart,
  flutter,
  git,
  java,
  js,
  kotlin,
  mongodb,
  nodejs,
  python,
  reactnative,
  reactjs,
  swift,
  typescript,
} from "./content/content";
import ReactList from "react-list";

type Props = {
  isIndex?: boolean,
};

const duration = 300;
const tutorialList = [
  algo,
  android,
  bootstrap,
  cpp,
  c,
  csharp,
  dart,
  flutter,
  git,
  java,
  js,
  kotlin,
  mongodb,
  nodejs,
  python,
  reactnative,
  reactjs,
  swift,
  typescript,
];

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};

const PageLinks = () => {
  return (
    <nav>
      <div key={"python"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/python-tutorials"
          id={styles["sidelist__a"]}
        >
          Python tutorials
        </a>
      </div>
      <div key={"java"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/java-tutorials"
          id={styles["sidelist__a"]}
        >
          Java tutorials
        </a>
      </div>
      <div key={"cpp"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/c-plus-plus-tutorials"
          id={styles["sidelist__a"]}
        >
          C++ tutorials
        </a>
      </div>
      <div key={"c"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/c-programming-examples"
          id={styles["sidelist__a"]}
        >
          C tutorials
        </a>
      </div>
      <div key={"javascript"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/javascript-tutorials"
          id={styles["sidelist__a"]}
        >
          Javascript tutorials
        </a>
      </div>
      <div key={"csharp"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/c-sharp-tutorials"
          id={styles["sidelist__a"]}
        >
          C# tutorials
        </a>
      </div>
      <div key={"ts"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/typescript-tutorials"
          id={styles["sidelist__a"]}
        >
          TypeScript tutorials
        </a>
      </div>
      <div key={"reactjs"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/reactjs-tutorials"
          id={styles["sidelist__a"]}
        >
          React.js tutorials
        </a>
      </div>
      <div key={"bootstrap"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/bootstrap-tutorials"
          id={styles["sidelist__a"]}
        >
          BootStrap tutorials
        </a>
      </div>
      <div key={"android"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/android-tutorials"
          id={styles["sidelist__a"]}
        >
          Android tutorials
        </a>
      </div>
      <div key={"reactnative"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/react-native-tutorials"
          id={styles["sidelist__a"]}
        >
          React Native tutorials
        </a>
      </div>
      <div key={"kotlin"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/kotlin-tutorials"
          id={styles["sidelist__a"]}
        >
          Kotlin tutorials
        </a>
      </div>
      <div key={"dart"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/dart-tutorials"
          id={styles["sidelist__a"]}
        >
          Dart tutorials
        </a>
      </div>
      <div key={"swift"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/swift-tutorials"
          id={styles["sidelist__a"]}
        >
          Swift/iOS tutorials
        </a>
      </div>
      <div key={"node"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/nodejs-tutorials"
          id={styles["sidelist__a"]}
        >
          Node.js tutorials
        </a>
      </div>
      <div key={"mongodb"} id={styles["sidelist__div"]}>
        <a
          href="https://www.codevscolor.com/pages/mongodb-tutorials"
          id={styles["sidelist__a"]}
        >
          MongoDB tutorials
        </a>
      </div>
      <div key={"about"} id={styles["sidelist__div"]}>
        <a href="https://codevscolor.com/pages/about" target="_blank" rel="noopener noreferrer">
          About
        </a>
      </div>
      <div key={"privacy"} id={styles["sidelist__div"]}>
        <a href="https://codevscolor.com/pages/privacy-policy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </a>
      </div>
      <div key={"privacy"} id={styles["sidelist__div"]}>
        <a href="https://codevscolor.com/pages/terms-of-services" target="_blank" rel="noopener noreferrer">
          T&C
        </a>
      </div>
      <div key={"privacy"} id={styles["sidelist__div"]}>
        <a href="https://codevscolor.com/pages/contact" target="_blank" rel="noopener noreferrer">
          Contact
        </a>
      </div>
    </nav>
  );
};

const Sidebar: React.FC<Props> = ({ isIndex, slug }) => {
  const wrapperRef = useRef();
  useEffect(() => wrapperRef.current && wrapperRef.classList.toggle("open"));
  const { author, copyright, menu } = useSiteMetadata();
  const [open, setOpen] = useState(false);

  const getLength = (slug) => {
    if (getTutorialList()) {
      let keys = Object.keys(getTutorialList());

      if (keys) {
        return keys.length;
      }
    }
    return 0;
  };

  const getTutorialList = () => {
    for (let index = 0; index < tutorialList.length; index++) {
      let i = Object.values(tutorialList[index]).findIndex((item) =>
        item.includes(slug)
      );

      if (i != -1) {
        // console.log(`found data for ${slug} ${Object.values(tutorialList[index])[i]}`);
        return tutorialList[index];
      }
    }
    // console.log('not found ..returning nll')
    return { "": "" };
  };

  const getStartIndex = () => {
    return Object.values(getTutorialList()).findIndex((item) =>
      item.includes(slug)
    );
  };

  const renderItem = (index, key) => {
    if (
      getTutorialList()[Object.keys(getTutorialList())[index]].includes(slug)
    ) {
      return (
        <div key={key} id={styles["sidelist__enable"]}>
          {Object.keys(getTutorialList())[index]}
        </div>
      );
    }

    return (
      <div
        key={key}
        id={styles["sidelist__div"]}
        onClick={() => setOpen(false)}
      >
        <a
          href={Object.values(getTutorialList())[index]}
          id={styles["sidelist__a"]}
        >
          {Object.keys(getTutorialList())[index]}
        </a>
      </div>
    );
  };

  return (
    <div style={{ flexDirection: "column" }}>
      <div id={styles["topbar"]}>
        <div
          id={styles["hambmenu"]}
          className={open ? styles["isopen"] : styles["close"]}
          onClick={() => setOpen(!open)}
        >
          <span />
          <span />
          <span />
          <span />
        </div>
        <Author author={author} isIndex={isIndex} />
        <div className={styles["links"]}>
          <div className={styles["dropdown"]}>
            <button className={styles["dropbtn"]}>Languages</button>
            <div className={styles["dropdown-content"]}>
              <a href="https://www.codevscolor.com/pages/python-tutorials">
                Python
              </a>
              <a href="https://www.codevscolor.com/pages/java-tutorials">
                Java
              </a>
              <a href="https://www.codevscolor.com/pages/c-plus-plus-tutorials">
                C++
              </a>
              <a href="https://www.codevscolor.com/pages/c-programming-examples">
                C
              </a>
              <a href="https://www.codevscolor.com/pages/javascript-tutorials">
                Javascript
              </a>
              <a href="https://www.codevscolor.com/pages/c-sharp-tutorials">
                C#
              </a>
            </div>
          </div>
          <div className={styles["dropdown"]}>
            <button className={styles["dropbtn"]}>Web</button>
            <div className={styles["dropdown-content"]}>
              <a href="https://www.codevscolor.com/pages/typescript-tutorials">
                TypeScript
              </a>
              <a href="https://www.codevscolor.com/pages/reactjs-tutorials">
                React.js
              </a>
              <a href="https://www.codevscolor.com/pages/bootstrap-tutorials">
                BootStrap
              </a>
            </div>
          </div>
          <div className={styles["dropdown"]}>
            <button className={styles["dropbtn"]}>Mobile</button>
            <div className={styles["dropdown-content"]}>
              <a href="https://www.codevscolor.com/pages/android-tutorials">
                Android
              </a>
              <a href="https://www.codevscolor.com/pages/react-native-tutorials">
                React Native
              </a>
              <a href="https://www.codevscolor.com/pages/flutter-tutorials">
                Flutter
              </a>
              <a href="https://www.codevscolor.com/pages/kotlin-tutorials">
                Kotlin
              </a>
              <a href="https://www.codevscolor.com/pages/dart-tutorials">
                Dart
              </a>
              <a href="https://www.codevscolor.com/pages/swift-tutorials">
                Swift/iOS
              </a>
            </div>
          </div>
          <div className={styles["dropdown"]}>
            <button className={styles["dropbtn"]}>Backend</button>
            <div className={styles["dropdown-content"]}>
              <a href="https://www.codevscolor.com/pages/nodejs-tutorials">
                Node.js
              </a>
              <a href="https://www.codevscolor.com/pages/mongodb-tutorials">
                MongoDB
              </a>
            </div>
          </div>
          <a href="https://discuss.codevscolor.com" target="_blank" rel="noopener noreferrer">
            Ask your question
          </a>
        </div>
        <div></div>

        <div className={styles["contacts"]}>
          <Contacts contacts={author.contacts} />
        </div>
        <SiteThemeToggler className={styles["sidebar__themetoggler"]} />
      </div>
      {slug && (
        <nav
          id={styles["sidelist"]}
          className={open ? styles["isopen"] : styles["close"]}
        >
          <div className={styles["mobilelinks"]}>
            <PageLinks />
          </div>
     <ReactList
            itemRenderer={renderItem}
            length={getLength()}
            minSize={15}
            initialIndex={getStartIndex()}
            useStaticSize={true}
            type="simple"
          /> 

          {/* <Copyright copyright={copyright} /> */}
        </nav>
      )}
      {!slug && (
        <nav
          id={styles["sidelist"]}
          className={open ? styles["isopen"] : styles["close"]}
        >
          <PageLinks />
        </nav>
      )}
    </div>
  );
};

export default Sidebar;
